import { useEffect } from "react";

/**
 * Site-wide structured data injected once on mount.
 * Combines Organization (LocalBusiness) and WebSite schemas so Google and
 * LLM crawlers (ChatGPT, Perplexity, Google AI Overviews) know the site is
 * a single business entity with a canonical name, phone, and service area.
 */
export default function SiteSchema() {
  useEffect(() => {
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    const graph = [
      {
        "@type": ["Organization", "LocalBusiness", "AutoRental"],
        "@id": `${origin}/#organization`,
        name: "B&L Rentals",
        alternateName: ["B and L Rentals", "BL Rentals"],
        url: origin,
        logo: `${origin}/favicon.ico`,
        image: `${origin}/hero-van.jpg`,
        telephone: "+1-805-290-8431",
        email: "hello@blrental.com",
        priceRange: "$$",
        address: {
          "@type": "PostalAddress",
          streetAddress: "Oxnard",
          addressLocality: "Oxnard",
          addressRegion: "CA",
          postalCode: "93030",
          addressCountry: "US",
        },
        areaServed: [
          { "@type": "City", name: "Oxnard" },
          { "@type": "City", name: "Ventura" },
          { "@type": "City", name: "Camarillo" },
          { "@type": "City", name: "Port Hueneme" },
          { "@type": "City", name: "Ojai" },
          { "@type": "AdministrativeArea", name: "Ventura County" },
        ],
        openingHours: "Mo-Su 07:00-21:00",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5.0",
          reviewCount: "200",
        },
        sameAs: [],
      },
      {
        "@type": "WebSite",
        "@id": `${origin}/#website`,
        url: origin,
        name: "B&L Rentals",
        publisher: { "@id": `${origin}/#organization` },
        inLanguage: "en-US",
        potentialAction: {
          "@type": "SearchAction",
          target: `${origin}/vehicles?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
    ];
    const doc = { "@context": "https://schema.org", "@graph": graph };
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-site-schema", "true");
    el.text = JSON.stringify(doc);
    document.head.appendChild(el);
    return () => { if (el.parentNode) el.parentNode.removeChild(el); };
  }, []);
  return null;
}
